import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ReferenceLink from '../ReferenceLink';

const mapStateToProps = (state, ownProps) => {
	return {
		hash: ownProps.location.hash, // location from withRouter
		method: ownProps.method
	};
};

export default withRouter(connect(mapStateToProps)(ReferenceLink));


// WEBPACK FOOTER //
// ./src/components/javascript-sdk/containers/ReferenceLinkContainer.js